import { useEffect } from "preact/hooks";
import { route } from "preact-router";
import type { RoutableProps } from "preact-router";
import { resendEditConfirmation } from "../api";
import { PendingConfirmation } from "../components/pendingConfirmation";
import { STRINGS } from "../constants/strings";
import { toErrorPath } from "../routes";

interface Props extends RoutableProps {
  editToken?: string;
}

export function EditPendingScreen({ editToken }: Props) {
  useEffect(() => {
    if (!editToken) route(toErrorPath("invalid"), true);
  }, [editToken]);

  if (!editToken) return null;

  return (
    <PendingConfirmation
      token={editToken}
      storagePrefix="review-edit"
      resend={resendEditConfirmation}
      title={STRINGS.editPendingTitle}
      body={STRINGS.editPendingBody}
      expiry={STRINGS.editPendingExpiry}
    />
  );
}
